import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function BestOnlinePicksLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg {...attributes} width="29" height="32" viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1107_7246)">
          <path
            d="M5.87941 0.632568H22.3294C25.2894 0.632568 27.6894 3.03257 27.6894 5.99257V25.3026C27.6894 28.2626 25.2894 30.6626 22.3294 30.6626H5.87941C2.91941 30.6626 0.519409 28.2626 0.519409 25.3026V5.99257C0.519409 3.03257 2.91941 0.632568 5.87941 0.632568Z"
            fill="white"
          />
          <path
            d="M22.3294 1.13257C25.0094 1.13257 27.1894 3.31257 27.1894 5.99257V25.3026C27.1894 27.9826 25.0094 30.1626 22.3294 30.1626H5.87941C3.19941 30.1626 1.01941 27.9826 1.01941 25.3026V5.99257C1.01941 3.31257 3.19941 1.13257 5.87941 1.13257H22.3294ZM22.3294 0.132568H5.87941C2.65941 0.132568 0.0194092 2.77257 0.0194092 5.99257V25.3026C0.0194092 28.5226 2.65941 31.1626 5.87941 31.1626H22.3294C25.5494 31.1626 28.1894 28.5226 28.1894 25.3026V5.99257C28.1894 2.77257 25.5494 0.132568 22.3294 0.132568Z"
            fill="black"
          />
          <path
            d="M19.0995 18.2325V20.2025H9.82947V18.2325H13.5795V6.77251C12.7395 7.20251 11.2895 7.74251 10.4795 7.98251L10.2095 6.15251C11.5795 5.69251 13.3095 4.91251 14.2295 4.32251H15.7695V18.2325H19.1095H19.0995Z"
            fill="black"
          />
          <path
            d="M14.7395 23.0225L15.1295 24.2125H16.3795C16.9095 24.2125 17.1295 24.8925 16.6995 25.2025L15.6895 25.9425L16.0795 27.1325C16.2395 27.6325 15.6695 28.0525 15.2395 27.7425L14.2295 27.0025L13.2195 27.7425C12.7895 28.0525 12.2195 27.6325 12.3795 27.1325L12.7695 25.9425L11.7595 25.2025C11.3295 24.8925 11.5495 24.2125 12.0795 24.2125H13.3295L13.7195 23.0225C13.8795 22.5225 14.5995 22.5225 14.7595 23.0225H14.7395Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1107_7246">
            <rect width="28.17" height="31.03" fill="white" transform="translate(0.0194092 0.132568)" />
          </clipPath>
        </defs>
      </svg>

      <span>Best Online Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
